import * as Yup from "yup";

export const AddBillsSchema = Yup.object().shape({
	comment : Yup.string(),
})